import { render, staticRenderFns } from "./uploads.vue?vue&type=template&id=6d6fd597&"
import script from "./uploads.vue?vue&type=script&lang=js&"
export * from "./uploads.vue?vue&type=script&lang=js&"
import style0 from "./uploads.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports